var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticStyle: { "margin-top": "5px" } },
          [
            !_vm.isDialog && _vm.isEdit && _vm.canUpdate
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary", no: "Cancel" },
                    on: { click: _vm.cancel }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                )
              : _vm._e(),
            !_vm.isDialog && _vm.isEdit && _vm.canUpdate
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary", no: "Save" },
                    on: { click: _vm.save }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                )
              : _vm._e(),
            !_vm.isDialog && !_vm.isEdit
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary", no: "Back" },
                    on: {
                      click: function($event) {
                        return _vm.$emit("back")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Back")))]
                )
              : _vm._e(),
            !_vm.isDialog && !_vm.isEdit && _vm.canUpdate
              ? _c(
                  "el-button",
                  {
                    attrs: {
                      disabled:
                        _vm.form.status2 ===
                        _vm.SystemConstants.QUOTE_STATUS_QUOTED.code,
                      type: "primary",
                      no: "Edit"
                    },
                    on: { click: _vm.edit }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                )
              : _vm._e(),
            !_vm.isDialog && _vm.canUpdate
              ? _c(
                  "el-button",
                  {
                    attrs: {
                      disabled:
                        _vm.isEdit ||
                        _vm.form.status2 ===
                          _vm.SystemConstants.QUOTE_STATUS_QUOTED.code,
                      type: "primary",
                      no: "submit"
                    },
                    on: {
                      click: function($event) {
                        return _vm.editStatus(
                          _vm.SystemConstants.QUOTE_ACTION_SUBMIT.code
                        )
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SubmitQuotation")))]
                )
              : _vm._e(),
            !_vm.isDialog && _vm.canUpdate
              ? _c(
                  "el-button",
                  {
                    attrs: {
                      disabled:
                        _vm.isEdit ||
                        _vm.form.status2 ===
                          _vm.SystemConstants.QUOTE_STATUS_PENDING.code,
                      type: "primary",
                      no: "revoke"
                    },
                    on: {
                      click: function($event) {
                        return _vm.editStatus(
                          _vm.SystemConstants.QUOTE_ACTION_REVOKE.code
                        )
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_WithdrawQuotation")))]
                )
              : _vm._e(),
            !_vm.isDialog && _vm.canUpdate
              ? _c(
                  "el-button",
                  {
                    attrs: {
                      disabled:
                        _vm.isEdit ||
                        _vm.form.status2 !==
                          _vm.SystemConstants.QUOTE_STATUS_PENDING.code,
                      type: "primary",
                      no: "refuse"
                    },
                    on: {
                      click: function(p) {
                        _vm.refuseQuotationDialog.visible = true
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_RejectQuotation")))]
                )
              : _vm._e(),
            _c("span", { staticStyle: { "font-size": "14px" } }, [
              _vm._v(" " + _vm._s(_vm.form.quotationNo) + " ")
            ]),
            _c(
              "span",
              {
                staticStyle: {
                  "font-size": "14px",
                  color: "red",
                  "margin-left": "5px"
                },
                attrs: { no: "status" }
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.ColumnUtils.showTypeLabelFunc(
                        _vm.form.status2,
                        _vm.SystemConstants.QUOTE_STATUS
                      ) +
                        (_vm.form.refuseReason
                          ? "(" + _vm.form.refuseReason + ")"
                          : "")
                    ) +
                    " "
                )
              ]
            )
          ],
          1
        ),
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                staticClass: "quotation-pre-port-form",
                staticStyle: {
                  "margin-top": "5px",
                  display: "flex",
                  "flex-wrap": "wrap"
                },
                attrs: {
                  disabled: "",
                  "label-width": "120px",
                  "label-position": "right"
                }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.ConsignationCompany") } },
                  [
                    _c("cargo-sales-company-select", {
                      attrs: {
                        no: "clientId",
                        "method-params": { customer: true, active: true },
                        "default-value": Number(_vm.form.clientId || 0)
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.form.clientId = p.cmpIdx + ""
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm.form.customerIdType ===
                _vm.SystemConstants.CUSTOMER_ID_TYPE_TEMPORARY.code
                  ? _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.Addr"), required: "" }
                      },
                      [_c("el-input", { attrs: { value: _vm.form.address } })],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_EnquiryNumber") } },
                  [
                    _c("el-input", {
                      attrs: { value: _vm.form.inquiryPriceNo, disabled: "" }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_Enquirer") } },
                  [
                    _c("cargo-user-select", {
                      attrs: {
                        "default-value": _vm.form.inquiryCreatedBy,
                        disabled: ""
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_PalletType"),
                      required: ""
                    }
                  },
                  [
                    _c("cargo-advance-select", {
                      attrs: {
                        no: "palletNature",
                        "tag-value": "code",
                        filterable: "",
                        clearable: false,
                        "default-value": _vm.form.palletNature,
                        "static-options": _vm.SystemConstants.PALLET_NATURES
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.form.palletNature = p.value
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("SeaExport.CargoReadyDate"),
                      required: ""
                    }
                  },
                  [
                    _c(
                      "el-tabs",
                      {
                        model: {
                          value: _vm.form.cargoReadyTimeType,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cargoReadyTimeType", $$v)
                          },
                          expression: "form.cargoReadyTimeType"
                        }
                      },
                      [
                        _c("el-tab-pane", {
                          attrs: {
                            disabled: "",
                            label: _vm.$t("CargoMsg.Cargo_Range"),
                            name:
                              _vm.SystemConstants.CARGO_READY_TIME_TYPE_RANGE
                                .code
                          }
                        }),
                        _c("el-tab-pane", {
                          attrs: {
                            disabled: "",
                            label: _vm.$t("CargoMsg.Cargo_Date"),
                            name:
                              _vm.SystemConstants.CARGO_READY_TIME_TYPE_DATE
                                .code
                          }
                        })
                      ],
                      1
                    ),
                    _vm.form.cargoReadyTimeType ===
                    _vm.SystemConstants.CARGO_READY_TIME_TYPE_RANGE.code
                      ? _c("cargo-advance-select", {
                          attrs: {
                            no: "cargoReadyTimeRange",
                            "tag-value": "code",
                            filterable: "",
                            clearable: false,
                            "default-value": _vm.form.cargoReadyTimeRange,
                            "static-options":
                              _vm.SystemConstants.CARGO_READY_TIME_RANGES
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.form.cargoReadyTimeRange = p.value
                            }
                          }
                        })
                      : _vm._e(),
                    _vm.form.cargoReadyTimeType ===
                    _vm.SystemConstants.CARGO_READY_TIME_TYPE_DATE.code
                      ? _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "cargoReadyTimeDate",
                            type: "datetime",
                            "value-format": "yyyy-MM-dd",
                            format: "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.form.cargoReadyTimeDate,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "cargoReadyTimeDate", $$v)
                            },
                            expression: "form.cargoReadyTimeDate"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_Terms") } },
                  [
                    _c("cargo-advance-select", {
                      attrs: {
                        no: "serviceTerm",
                        filterable: "",
                        "select-type": _vm.TYPE_NAMES.basic_data_IncoTerm,
                        "callback-method-type": "value",
                        "default-value": _vm.form.serviceTerm,
                        "callback-params": { key: "incoTerm" }
                      },
                      on: {
                        parentCallBack: function(p) {
                          return (_vm.form.serviceTerm = p.value)
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_DirectOrTransshipment"),
                      required: ""
                    }
                  },
                  [
                    _c("cargo-advance-select", {
                      attrs: {
                        no: "directTransit",
                        "tag-value": "code",
                        filterable: "",
                        clearable: false,
                        "default-value": _vm.form.directTransit,
                        "static-options": _vm.SystemConstants.DIRECT_TRANSITS
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.form.directTransit = p.value
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm.form.directTransit ===
                _vm.SystemConstants.DIRECT_TRANSIT_TRANSIT.code
                  ? _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.TransitPort"),
                          required: ""
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                            filterable: "",
                            "default-value": _vm.form.transferPortCode
                          },
                          on: {
                            parentCallBack: function(p) {
                              return (_vm.form.transferPortCode = p.value)
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_Airline"),
                      required: ""
                    }
                  },
                  [
                    _c("cargo-advance-select", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        "select-type": _vm.TYPE_NAMES.basic_data_Region,
                        filterable: "",
                        "default-value": _vm.form.commerceCode
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.form.commerceCode = p.value
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: _vm.$t("CargoMsg.Cargo_POL"), required: "" }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        value: _vm.ColumnUtils.getSeaAirPortLabel(_vm.form.pol)
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_PortOfDischarge"),
                      required: ""
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        value: _vm.ColumnUtils.getSeaAirPortLabel(_vm.form.pod)
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.CargoType") } },
                  [
                    _c("cargo-advance-select", {
                      attrs: {
                        no: "cargoType",
                        filterable: "",
                        "select-type": _vm.TYPE_NAMES.basic_data_CargoType,
                        "callback-method-type": "value",
                        "default-value": _vm.form.cargoType,
                        "callback-params": { key: "cargoType" }
                      },
                      on: {
                        parentCallBack: function(p) {
                          return (_vm.form.cargoType = p.value)
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm.form.cargoType ===
                _vm.ImportConstants.CARGOTYPE_DANGEROUS.code
                  ? _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.DangerousClass"),
                          required: ""
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "dangerousGoodsLevel",
                            "tag-value": "code",
                            filterable: "",
                            clearable: false,
                            "default-value": _vm.form.dangerousGoodsLevel,
                            "static-options":
                              _vm.SystemConstants.DANGEROUS_GOODS_LEVELS
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.form.dangerousGoodsLevel = p.value
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.form.cargoType ===
                _vm.ImportConstants.CARGOTYPE_DANGEROUS.code
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "UN NO", required: "" } },
                      [
                        _c("el-input-number", {
                          attrs: {
                            no: "unNo",
                            "controls-position": "right",
                            precision: 0,
                            min: 0,
                            max: 9999
                          },
                          model: {
                            value: _vm.form.unNo,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "unNo", $$v)
                            },
                            expression: "form.unNo"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.form.cargoType === _vm.ImportConstants.CARGOTYPE_OOG.code
                  ? _c(
                      "el-form-item",
                      {
                        staticClass: "length-weight-height",
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_Dimensions"),
                          required: ""
                        }
                      },
                      [
                        _c("cargo-length-width-height", {
                          staticStyle: { width: "300px" },
                          attrs: { form: _vm.form }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.form.cargoType === _vm.ImportConstants.CARGOTYPE_FROZEN.code
                  ? _c(
                      "el-form-item",
                      {
                        staticClass: "with-unit",
                        attrs: {
                          label: _vm.$t("SeaExport.Temperature"),
                          required: ""
                        }
                      },
                      [
                        _c("el-input-number", {
                          attrs: {
                            no: "temperature",
                            "controls-position": "right",
                            precision: 0
                          },
                          model: {
                            value: _vm.form.temperature,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "temperature", $$v)
                            },
                            expression: "form.temperature"
                          }
                        }),
                        _c("span", [_vm._v("℃")])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.form.cargoType === _vm.ImportConstants.CARGOTYPE_FROZEN.code
                  ? _c(
                      "el-form-item",
                      {
                        staticClass: "with-unit",
                        attrs: {
                          label: _vm.$t("SeaExport.VentilationQuantity"),
                          required: ""
                        }
                      },
                      [
                        _c("el-input-number", {
                          attrs: {
                            no: "ventilationQuantity",
                            "controls-position": "right",
                            precision: 0
                          },
                          model: {
                            value: _vm.form.ventilationQuantity,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "ventilationQuantity", $$v)
                            },
                            expression: "form.ventilationQuantity"
                          }
                        }),
                        _c("span", [_vm._v("%")])
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_NameHSCode"),
                      required: ""
                    }
                  },
                  [_c("el-input", { attrs: { value: _vm.form.goodsName } })],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "with-unit",
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_Weight"),
                      required: ""
                    }
                  },
                  [
                    _c("el-input-number", {
                      attrs: {
                        no: "weight",
                        "controls-position": "right",
                        disabled: true,
                        precision: 2,
                        min: 0
                      },
                      model: {
                        value: _vm.form.grossWeight,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "grossWeight", $$v)
                        },
                        expression: "form.grossWeight"
                      }
                    }),
                    _c("span", [_vm._v("KGS")])
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.ShippingCompany") } },
                  [
                    _c("cargo-advance-select", {
                      attrs: {
                        no: "carrierId",
                        filterable: "",
                        "select-type": _vm.TYPE_NAMES.basic_data_Company,
                        "method-params": { seaCmp: true, active: true },
                        "default-value": _vm.form.carrierId || "",
                        placeholder: " "
                      },
                      on: {
                        parentCallBack: function(p) {
                          return (_vm.form.carrierId = p.value)
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") } },
                  [_c("el-input", { attrs: { value: _vm.form.remarks } })],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_20GPQuantity") } },
                  [
                    _c("el-input-number", {
                      staticStyle: { width: "300px" },
                      attrs: {
                        no: "gp20Num",
                        min: 0,
                        precision: 0,
                        "controls-position": "right"
                      },
                      model: {
                        value: _vm.form.num20,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "num20", $$v)
                        },
                        expression: "form.num20"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_40GPQuantity") } },
                  [
                    _c("el-input-number", {
                      staticStyle: { width: "300px" },
                      attrs: {
                        no: "gp40Num",
                        min: 0,
                        precision: 0,
                        "controls-position": "right"
                      },
                      model: {
                        value: _vm.form.num40,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "num40", $$v)
                        },
                        expression: "form.num40"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_40HCQuantity") } },
                  [
                    _c("el-input-number", {
                      staticStyle: { width: "300px" },
                      attrs: {
                        no: "hc40Num",
                        min: 0,
                        precision: 0,
                        "controls-position": "right"
                      },
                      model: {
                        value: _vm.form.numHc,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "numHc", $$v)
                        },
                        expression: "form.numHc"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_45HCQuantity") } },
                  [
                    _c("el-input-number", {
                      staticStyle: { width: "300px" },
                      attrs: {
                        no: "hc45Num",
                        min: 0,
                        precision: 0,
                        "controls-position": "right"
                      },
                      model: {
                        value: _vm.form.num45,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "num45", $$v)
                        },
                        expression: "form.num45"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_20NORQuantity") } },
                  [
                    _c("el-input-number", {
                      staticStyle: { width: "300px" },
                      attrs: {
                        no: "nor20Num",
                        min: 0,
                        precision: 0,
                        "controls-position": "right"
                      },
                      model: {
                        value: _vm.form.num20Nor,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "num20Nor", $$v)
                        },
                        expression: "form.num20Nor"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_40NORQuantity") } },
                  [
                    _c("el-input-number", {
                      staticStyle: { width: "300px" },
                      attrs: {
                        no: "nor40Num",
                        min: 0,
                        precision: 0,
                        "controls-position": "right"
                      },
                      model: {
                        value: _vm.form.num40Nor,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "num40Nor", $$v)
                        },
                        expression: "form.num40Nor"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    staticClass: "form-item-200",
                    staticStyle: { width: "880px" },
                    attrs: {
                      inline: true,
                      disabled: "",
                      "label-position": "right"
                    }
                  },
                  [
                    _c("cargo-area", {
                      staticClass: "area",
                      staticStyle: { display: "inline-block" },
                      attrs: {
                        no: "city",
                        country: "CN",
                        province: _vm.form.province,
                        city: _vm.form.city,
                        district: _vm.form.districts,
                        town: _vm.form.townUuid,
                        "show-town": true,
                        "select-width": 165
                      },
                      on: {
                        "update:province": function($event) {
                          return _vm.$set(_vm.form, "province", $event)
                        },
                        "update:city": function($event) {
                          return _vm.$set(_vm.form, "city", $event)
                        },
                        "update:district": function($event) {
                          return _vm.$set(_vm.form, "districts", $event)
                        },
                        "update:town": function($event) {
                          return _vm.$set(_vm.form, "townUuid", $event)
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("Partners.detailAddress") } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "300px" },
                      attrs: { type: "textarea", rows: 3 },
                      model: {
                        value: _vm.form.detailAddress,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "detailAddress", $$v)
                        },
                        expression: "form.detailAddress"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-left": "20px" },
                    attrs: {
                      label: _vm.$t("SeaExport.transportation"),
                      required: ""
                    }
                  },
                  [
                    _c(
                      "el-radio-group",
                      {
                        staticStyle: { width: "300px" },
                        model: {
                          value: _vm.form.transportMode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "transportMode", $$v)
                          },
                          expression: "form.transportMode"
                        }
                      },
                      [
                        _c(
                          "el-radio",
                          {
                            staticStyle: { "margin-right": "5px" },
                            attrs: {
                              label:
                                _vm.SystemConstants.PRICE_METHOD_DIRECT.code
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DirectHaul")))]
                        ),
                        _c(
                          "el-radio",
                          {
                            staticStyle: { "margin-right": "5px" },
                            attrs: {
                              label:
                                _vm.SystemConstants.PRICE_METHOD_BRANCH.code
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SideLine")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.form.transportMode ===
                _vm.SystemConstants.PRICE_METHOD_BRANCH.code
                  ? _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_SideLineType"),
                          required: ""
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticStyle: { width: "300px" },
                          attrs: {
                            no: "branchLine",
                            "tag-value": "code",
                            filterable: "",
                            clearable: false,
                            "default-value": _vm.form.branchLine,
                            "static-options": _vm.SystemConstants.BRANCH_LINES
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.form.branchLine = p.value
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section", staticStyle: { width: "100%" } },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("Pricing.PriceInfo")))
                ]),
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "10px" },
                        attrs: {
                          disabled: !_vm.isEdit,
                          no: "onAddC",
                          type: "primary"
                        },
                        on: { click: _vm.addQuotationDetail }
                      },
                      [_vm._v(_vm._s(_vm.$t("Pricing.Add")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled: !_vm.isEdit,
                          no: "onDeleteC",
                          type: "danger"
                        },
                        on: { click: _vm.delQuotationDetail }
                      },
                      [_vm._v(_vm._s(_vm.$t("Pricing.Delete")))]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "section grid-wrapper" },
                  [
                    _c("cargo-ag-grid-wrapper", {
                      staticStyle: { height: "100%" },
                      attrs: {
                        "config-module": "2025050282",
                        "grid-options": _vm.gridOptions,
                        "column-defs": _vm.columnDefs,
                        "row-data": _vm.form.prePortLastMileDetails,
                        "show-selected-color": false,
                        "check-sub-record": false
                      },
                      on: {
                        gridReady: function(params) {
                          _vm.gridApi = params.api
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "section", staticStyle: { width: "100%" } },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ChargeByContainerType")))
                ]),
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { disabled: !_vm.isEdit, type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.addChargingItem(
                              _vm.SystemConstants.CHARGING_ITEM_TYPE_BY_EQ_SIZE
                                .code
                            )
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { disabled: !_vm.isEdit, type: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.delChargingItem(
                              _vm.SystemConstants.CHARGING_ITEM_TYPE_BY_EQ_SIZE
                                .code
                            )
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "section grid-wrapper" },
                  [
                    _c("cargo-ag-grid-wrapper", {
                      staticStyle: { height: "100%" },
                      attrs: {
                        "config-module": "2025050283",
                        "grid-options": _vm.chargingItemByEqSize.gridOptions,
                        "column-defs": _vm.getColumnDefsByEqSize,
                        "row-data": _vm.selectedRow
                          ? _vm.selectedRow.byEqSizeChargingItems
                          : [],
                        "show-selected-color": false,
                        "check-sub-record": false
                      },
                      on: {
                        gridReady: function(params) {
                          _vm.chargingItemByEqSize.gridApi = params.api
                        }
                      }
                    })
                  ],
                  1
                ),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("CargoMsg.Cargo_ChargeNotByContainerType"))
                  )
                ]),
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { disabled: !_vm.isEdit, type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.addChargingItem(
                              _vm.SystemConstants
                                .CHARGING_ITEM_TYPE_NOT_BY_EQ_SIZE.code
                            )
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { disabled: !_vm.isEdit, type: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.delChargingItem(
                              _vm.SystemConstants
                                .CHARGING_ITEM_TYPE_NOT_BY_EQ_SIZE.code
                            )
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "section grid-wrapper" },
                  [
                    _c("cargo-ag-grid-wrapper", {
                      staticStyle: { height: "100%" },
                      attrs: {
                        "config-module": "2025050284",
                        "grid-options": _vm.chargingItemNotByEqSize.gridOptions,
                        "column-defs": _vm.getColumnDefsNotByEqSize,
                        "row-data": _vm.selectedRow
                          ? _vm.selectedRow.notByEqSizeChargingItems
                          : [],
                        "show-selected-color": false,
                        "check-sub-record": false
                      },
                      on: {
                        gridReady: function(params) {
                          _vm.chargingItemNotByEqSize.gridApi = params.api
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm.form && _vm.form.uuid
              ? _c(
                  "div",
                  { staticClass: "section", staticStyle: { width: "100%" } },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("Pricing.FileHistory")))
                    ]),
                    _vm.isEdit
                      ? _c(
                          "el-form",
                          { staticClass: "section" },
                          [
                            _c(
                              "el-row",
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "toFileQuery",
                                          type: "primary"
                                        },
                                        on: { click: _vm.toFileQuery }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("FileHistory.Refresh"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName: "v-permission",
                                            value: [
                                              "button_FileHistory_fileUpload"
                                            ],
                                            expression:
                                              "['button_FileHistory_fileUpload']"
                                          }
                                        ],
                                        attrs: {
                                          no: "upload",
                                          type: "primary"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.file.cloudFile.visible = true
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("FileHistory.Upload"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName: "v-permission",
                                            value: [
                                              "button_FileHistory_fileDelete",
                                              "role_FileDownloads_ownFileDelete"
                                            ],
                                            expression:
                                              "['button_FileHistory_fileDelete', 'role_FileDownloads_ownFileDelete']"
                                          }
                                        ],
                                        attrs: {
                                          no: "fileRemove",
                                          type: "danger"
                                        },
                                        on: { click: _vm.fileRemove }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("FileHistory.Delete"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "fileDownload",
                                          type: "primary"
                                        },
                                        on: { click: _vm.fileDownload }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FileHistory.BatchDownload")
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "fileSendEmail",
                                          type: "primary"
                                        },
                                        on: { click: _vm.fileSendEmail }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("FileHistory.SendEmail")
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form",
                      {
                        staticClass: "section",
                        attrs: { disabled: !_vm.isEdit }
                      },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c("cargo-ag-grid", {
                                  key: "25070802",
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    "config-module": "25070802",
                                    "grid-params": _vm.file.gridParams,
                                    "grid-options": _vm.file.gridOptions,
                                    "column-defs": _vm.file.columnDefs,
                                    "row-data": _vm.file.rowData
                                  },
                                  on: {
                                    "update:gridParams": function($event) {
                                      return _vm.$set(
                                        _vm.file,
                                        "gridParams",
                                        $event
                                      )
                                    },
                                    "update:grid-params": function($event) {
                                      return _vm.$set(
                                        _vm.file,
                                        "gridParams",
                                        $event
                                      )
                                    },
                                    gridReady: function(params) {
                                      _vm.file.gridApi = params.api
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _c("cargo-cloud-file-upload", {
        attrs: {
          visible: _vm.file.cloudFile.visible,
          job: _vm.fileCloudFileJob,
          lob: _vm.file.cloudFile.lob
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.file.cloudFile, "visible", $event)
          },
          uploadDone: _vm.toFileQuery
        }
      }),
      _vm.file.isShowingDetailForm
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                "close-on-click-modal": false,
                visible: _vm.file.isShowingDetailForm,
                title: _vm.file.showDetailTitle,
                width: "450px"
              },
              on: {
                close: function() {
                  return (_vm.file.isShowingDetailForm = false)
                }
              }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "400px", height: "300px" },
                attrs: {
                  "grid-options": _vm.file.gridOptionsFileDetail,
                  "column-defs": _vm.file.columnDefsFileDetail,
                  "row-data": _vm.file.rowDataFileDetail
                },
                on: {
                  gridReady: function(params) {
                    return (_vm.file.gridApiFileDetail = params.api)
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.file.sendEmailDialog.visible
        ? _c("send-email-dialog", {
            ref: "file.sendEmailDialog",
            attrs: {
              visible: _vm.file.sendEmailDialog.visible,
              context: null,
              job: _vm.fileCloudFileJob,
              source: "quotationDetailDialog",
              "send-email-data": _vm.file.sendEmailDialog
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.file.sendEmailDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            no: "refuseQuotationDialog",
            visible: _vm.refuseQuotationDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_Tips"),
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": true
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.refuseQuotationDialog, "visible", $event)
            },
            close: function($event) {
              _vm.refuseQuotationDialog.visible = false
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "70px", "label-position": "right" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-left": "230px",
                    "margin-top": "5px",
                    "margin-bottom": "5px",
                    "font-size": "larger"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmRejectQuote")))]
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Partners.RefuseRemark") + ":" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "450px" },
                    attrs: { no: "refuseReason", type: "textarea", rows: 6 },
                    model: {
                      value: _vm.refuseQuotationDialog.refuseReason,
                      callback: function($$v) {
                        _vm.$set(_vm.refuseQuotationDialog, "refuseReason", $$v)
                      },
                      expression: "refuseQuotationDialog.refuseReason"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "confirm", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.editStatus(
                        _vm.SystemConstants.QUOTE_ACTION_REFUSE.code
                      )
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function(p) {
                      _vm.refuseQuotationDialog.refuseReason = ""
                      _vm.refuseQuotationDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }